import {Empty} from 'antd';
import React, {FC} from 'react';

import {IReportConfigurationQueryParameterDto} from 'store/slices/report-configuration-slice/report-configuration-dto';

import {TableReportFilterField} from './filter-field/filter-field';

import './table-report-filter.less';

export interface ITableReportFilterProps {
    filterKeyPath: 'paramName' | 'columnName';
    queryParameters?: IReportConfigurationQueryParameterDto[];
    areParametersApplied: boolean;
}

export const TableReportFilter: FC<ITableReportFilterProps> = ({
    filterKeyPath,
    queryParameters,
    areParametersApplied,
}: ITableReportFilterProps) => {
    if (!queryParameters?.length) {
        return <Empty description="Для отчета отсутствуют параметры фильтрации в настройке отчетных форм" />;
    }

    return (
        <>
            {queryParameters?.map(queryParameter => (
                queryParameter.visible && (
                    <TableReportFilterField
                        filterKeyPath={filterKeyPath}
                        queryParameter={queryParameter}
                        areParametersApplied={areParametersApplied}
                    />
                )
            ))}
        </>
    );
};
